import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/Offend/web-application/WebApplicationPenetrationTest.tsx");
